var Const = /** @class */ (function () {
    function Const() {
    }
    Const.BREAKFAST_OPTIONS = '/BREAKFAST_OPTIONS';
    Const.WEIGHT_OPTIONS = '/WEIGHT_OPTIONS';
    Const.MOOD_OPTIONS = '/MOOD_OPTIONS';
    Const.BOWEL_MOVEMENTS_OPTIONS = '/BOWEL_MOVEMENTS_OPTIONS';
    Const.POOP_COLOR_OPTIONS = '/POOP_COLOR_OPTIONS';
    Const.POOP_EXPERIENCE_OPTIONS = '/POOP_EXPERIENCE_OPTIONS';
    Const.TIME_DURATION_OPTIONS = '/TIME_DURATION_OPTIONS';
    Const.PUSH_PRESSURE_OPTIONS = '/PUSH_PRESSURE_OPTIONS';
    Const.POOP_COMPLICATIONS_OPTIONS = '/POOP_COMPLICATIONS_OPTIONS';
    // ===================== dashboard formsss =============
    Const.RUN_ADD_FOOD_INTAKE = '/RUN_ADD_FOOD_INTAKE';
    Const.RUN_ADD_WEIGHT = '/RUN_ADD_WEIGHT';
    Const.RUN_ADD_BLOOD_PRESSURE = '/RUN_ADD_BLOOD_PRESSURE';
    Const.RUN_ADD_GLUCOSE_DATA = '/RUN_ADD_GLUCOSE_DATA';
    Const.RUN_ADD_EMOTION_DATA = '/RUN_ADD_EMOTION_DATA';
    Const.RUN_ADD_DIGESTION_DATA = '/RUN_ADD_DIGESTION_DATA';
    Const.RUN_ADD_SLEEP_DATA = '/RUN_ADD_SLEEP_DATA';
    Const.RUN_REGISTER_DISEASE_LIST = '/RUN_REGISTER_DISEASE_LIST';
    Const.SET_REGISTER_DISEASE_LIST = '/SET_REGISTER_DISEASE_LIST';
    Const.GET_REGISTER_DISEASE_LIST = '/GET_REGISTER_DISEASE_LIST';
    //===================================prescription
    Const.RUN_GET_PATIENT_PRESCRIPTION_LIST = '/RUN_GET_PATIENT_PRESCRIPTION_LIST';
    Const.SET_PATIENT_PRESCRIPTION_LIST = '/SET_PATIENT_PRESCRIPTION_LIST';
    Const.GET_PATIENT_PRESCRIPTION_LIST = '/GET_PATIENT_PRESCRIPTION_LIST';
    Const.RUN_GET_PATIENT_PRESCRIPTION_DETAIL = '/RUN_GET_PATIENT_PRESCRIPTION_DETAIL';
    Const.SET_PATIENT_PRESCRIPTION_DETAIL = '/SET_PATIENT_PRESCRIPTION_DETAIL';
    Const.GET_PATIENT_PRESCRIPTION_DETAIL = '/GET_PATIENT_PRESCRIPTION_DETAIL';
    Const.RUN_PATIENT_ADDEDIT_PRESCRIPTION = '/RUN_PATIENT_ADDEDIT_PRESCRIPTION';
    //===================================test-report
    Const.RUN_GET_PATIENT_TEST_REPORT_LIST = '/RUN_GET_PATIENT_TEST_REPORT_LIST';
    Const.SET_PATIENT_TEST_REPORT_LIST = '/SET_PATIENT_TEST_REPORT_LIST';
    Const.GET_PATIENT_TEST_REPORT_LIST = '/GET_PATIENT_TEST_REPORT_LIST';
    Const.RUN_GET_PATIENT_TEST_REPORT_DETAIL = '/RUN_GET_PATIENT_TEST_REPORT_DETAIL';
    Const.SET_PATIENT_TEST_REPORT_DETAIL = '/SET_PATIENT_TEST_REPORT_DETAIL';
    Const.GET_PATIENT_TEST_REPORT_DETAIL = '/GET_PATIENT_TEST_REPORT_DETAIL';
    Const.RUN_UPLOAD_PATIENT_TEST_REPORT = '/RUN_UPLOAD_PATIENT_TEST_REPORT';
    Const.RUN_EDIT_PATIENT_TEST_REPORT = '/RUN_EDIT_PATIENT_TEST_REPORT';
    //===================================appointment
    Const.RUN_GET_APPOINTMENT_LIST = '/RUN_GET_APPOINTMENT_LIST';
    Const.SET_APPOINTMENT_LIST = '/SET_APPOINTMENT_LIST';
    Const.GET_APPOINTMENT_LIST = '/GET_APPOINTMENT_LIST';
    Const.RUN_GET_APPOINTMENT_DETAIL = '/RUN_GET_APPOINTMENT_DETAIL';
    Const.SET_APPOINTMENT_DETAIL = '/SET_APPOINTMENT_DETAIL';
    Const.GET_APPOINTMENT_DETAIL = '/GET_APPOINTMENT_DETAIL';
    Const.RUN_GET_APPOINTMENT_INFO = '/RUN_GET_APPOINTMENT_INFO';
    Const.SET_APPOINTMENT_INFO = '/SET_APPOINTMENT_INFO';
    Const.GET_APPOINTMENT_INFO = '/GET_APPOINTMENT_INFO';
    Const.RUN_ADD_APPOINTMENT = '/RUN_ADD_APPOINTMENT';
    Const.RUN_GET_DOCTOR_DETAI = '/RUN_GET_DOCTOR_DETAI';
    Const.RUN_GET_AVAILABLE_SLOTS_LIST = '/RUN_GET_AVAILABLE_SLOTS_LIST';
    Const.SET_AVAILABLE_SLOTS_LIST = '/SET_AVAILABLE_SLOTS_LIST';
    Const.GET_AVAILABLE_SLOTS_LIST = '/GET_AVAILABLE_SLOTS_LIST';
    Const.RUN_GET_BUSY_SLOT_LIST = '/RUN_GET_BUSY_SLOT_LIST';
    Const.SET_BUSY_SLOT_LIST = '/SET_BUSY_SLOT_LIST';
    Const.GET_BUSY_SLOT_LIST = '/GET_BUSY_SLOT_LIST';
    //===============================obt call
    Const.RUN_BOOK_OBT_CALL = '/RUN_BOOK_OBT_CALL';
    Const.RUN_CHECK_OBT_CALL = '/RUN_CHECK_OBT_CALL';
    Const.SET_CHECK_OBT_CALL = '/SET_CHECK_OBT_CALL';
    Const.GET_CHECK_OBT_CALL = '/GET_CHECK_OBT_CALL';
    //===================================notification
    Const.RUN_GET_NOTIFICATION_LIST = '/RUN_GET_NOTIFICATION_LIST';
    Const.SET_NOTIFICATION_LIST = '/SET_NOTIFICATION_LIST';
    Const.GET_NOTIFICATION_LIST = '/GET_NOTIFICATION_LIST';
    //===================================initial data
    Const.RUN_GET_INITIAL_DATA = '/RUN_GET_INITIAL_DATA';
    Const.SET_INITIAL_DATA = '/SET_INITIAL_DATA';
    Const.GET_INITIAL_DATA = '/GET_INITIAL_DATA';
    //===================================chart data
    Const.RUN_GET_CHART_DATA = '/RUN_GET_CHART_DATA';
    Const.SET_CHART_DATA = '/SET_CHART_DATA';
    Const.GET_CHART_DATA = '/GET_CHART_DATA';
    //===================================chart data
    Const.RUN_GET_MEDICINE_LIST = '/RUN_GET_MEDICINE_LIST';
    Const.SET_MEDICINE_LIST = '/SET_MEDICINE_LIST';
    Const.GET_MEDICINE_LIST = '/GET_MEDICINE_LIST';
    //===================================chart data
    Const.RUN_GET_TASK_ACTION_LIST = '/RUN_GET_TASK_ACTION_LIST';
    Const.SET_TASK_ACTION_LIST = '/SET_TASK_ACTION_LIST';
    Const.GET_TASK_ACTION_LIST = '/GET_TASK_ACTION_LIST';
    Const.RUN_GET_PATIENT_BUSY_SLOT = '/RUN_GET_PATIENT_BUSY_SLOT';
    Const.SET_PATIENT_BUSY_SLOT = '/SET_PATIENT_BUSY_SLOT';
    Const.GET_PATIENT_BUSY_SLOT = '/GET_PATIENT_BUSY_SLOT';
    Const.RUN_EDIT_PROFILE = '/RUN_EDIT_PROFILE';
    Const.RUN_EDIT_PROFILE_PIC = '/RUN_EDIT_PROFILE_PIC';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/Gini/provider/candle-history/lib/const.cls.ts
// module id = null
// module chunks = 